import { ProductLink } from '@portals/core/src/components/ProductLink/ProductLink';
import React from 'react';

import { InternServiceLink as InternCategoryLinkModel } from '../../../models';
import { useLinkProps } from '../../hooks/useLinkProps';
import { loadIcon } from '../../utils/loadIcon';

interface Props {
  node: InternCategoryLinkModel;
}

export const InternCategoryLink: React.FunctionComponent<Props> = ({ node }: Props) => {
  const { singleProps } = useLinkProps(node.link[0]);
  const Icon = loadIcon(node.icon?.icon);
  const startIcon = node.icon?.icon ? <Icon /> : null;

  return (
    <ProductLink key={node.id} data-selector={`${node.__component}.${node.id}`} {...singleProps} startIcon={startIcon}>
      {node.link[0]?.text}
    </ProductLink>
  );
};
